import { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import Form from 'components/atoms/Form';
import Icon from 'components/atoms/Icon';
import { bindActionCreators, Dispatch } from 'redux';
import { setOutlineIntervalAction } from 'store/actions/mapActions';
import { RootState } from 'types';
import { ActionsType } from 'types/system';
import { translate } from 'utils/translate';

interface LoadPlaybackModeVesselErrorModelProps {
    children?: string | JSX.Element | JSX.Element[];
    title?: string;
    language: string;
    id?: string;
    data: any;
    actions: ActionsType | undefined;
    setOutlineIntervalAction: (outlineInterval: number) => void;
}

interface LoadPlaybackModeVesselErrorModelState {
    language: string;
    errors: object;
    data: any | null;
    id?: string;
}

class LoadPlaybackModeVesselErrorModel extends Component<
    LoadPlaybackModeVesselErrorModelProps,
    LoadPlaybackModeVesselErrorModelState
> {
    constructor(props: LoadPlaybackModeVesselErrorModelProps) {
        super(props);
        this.state = {
            data: null,
            errors: {},
            language: 'en',
        };
    }

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.props.actions?.onConfirm();
        this.props.actions?.onCancel();
    };

    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    render() {
        return (
            <Form onSubmit={this.handleFormSubmit} className="bg-white shadow w-mediumModel  rounded ">
                <div className="p-4 no-select">
                    <div id={`Drag-${this.props.id}`} className="flex justify-between">
                        <div className="text-lg leading-6 font-bold">{translate('Data request failed.')}</div>
                        <div className="cursor-pointer" onClick={this.handleFormCancel}>
                            <Icon className="w-6 h-6">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>
                    <div className="text-md text-gray-500 mt-5 ">
                        {translate(
                            'the vessel data request could not be loaded. please check your network connection or try again later.'
                        )}
                    </div>

                    <div className="flex justify-end pt-4 ">
                        <div className="flex gap-2 items-center">
                            <Button
                                className="px-4 py-2 font-bold border border-gray-400"
                                onClick={this.handleFormCancel}
                            >
                                {translate('Cancel')}
                            </Button>
                        </div>
                    </div>
                </div>
            </Form>
        );
    }
}

const loadPlaybackModeVesselErrorModelStateToProps = (state: RootState) => ({
    language: state.user.user.language,
});

const loadPlaybackModeVesselErrorModelDispatchToProps = (dispatch: Dispatch) => ({
    setOutlineIntervalAction: bindActionCreators(setOutlineIntervalAction, dispatch),
});

export default connect(
    loadPlaybackModeVesselErrorModelStateToProps,
    loadPlaybackModeVesselErrorModelDispatchToProps
)(LoadPlaybackModeVesselErrorModel);
